import { render, staticRenderFns } from "./UpdateDevicePeripheralDeviceModal.vue?vue&type=template&id=c8e82070&"
import script from "./UpdateDevicePeripheralDeviceModal.vue?vue&type=script&lang=js&"
export * from "./UpdateDevicePeripheralDeviceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports